function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M5.75 16.11V7.9A2.992 2.992 0 005 2.01c-1.66 0-3 1.34-3 3 0 1.4.96 2.56 2.25 2.89v8.21A2.992 2.992 0 005 22c1.66 0 3-1.34 3-3 0-1.4-.96-2.56-2.25-2.89z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.75 16.11V6.5c0-1.52-1.23-2.75-2.75-2.75h-2.93l1.41-1.17c.32-.27.36-.74.1-1.06a.758.758 0 00-1.06-.1l-3 2.5a.761.761 0 000 1.16l3 2.5c.14.12.31.17.48.17a.75.75 0 00.48-1.33l-1.41-1.17H17c.69 0 1.25.56 1.25 1.25v9.61A2.992 2.992 0 0019 22c1.66 0 3-1.34 3-3 0-1.4-.96-2.56-2.25-2.89z"
})));